var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftTeamsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.188 8.803a2.193 2.193 0 002.187-2.2c0-1.213-.98-2.198-2.187-2.198A2.193 2.193 0 0017 6.604c0 1.214.98 2.199 2.188 2.199z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.534 16.344v-5.97a.944.944 0 00-.936-.943h3.465c.514 0 .937.425.937.942v4.673c-.001 1.724-1.413 3.142-3.129 3.142-.216 0-.43-.022-.642-.066l-.02-.005c.21-.553.325-1.15.325-1.773zm-7.368-9.426H2.833A.84.84 0 002 7.755v8.376c0 .46.376.838.833.838h8.333A.84.84 0 0012 16.13V7.755a.84.84 0 00-.833-.837zM7.62 10.043h1.869V8.806H4.513v1.238h1.879v5.038h1.227v-5.039z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.989 6.918h2.086a.84.84 0 01.833.837v.825a2.926 2.926 0 002.634-2.918 2.924 2.924 0 00-2.917-2.932 2.924 2.924 0 00-2.917 2.932c0 .45.1.875.28 1.256zm-2.126 10.96a4.525 4.525 0 00.437.976 4.997 4.997 0 004.328 2.512c2.741 0 4.997-2.267 4.997-5.022v-5.97a.944.944 0 00-.936-.943h-3.78v7.61a.84.84 0 01-.834.837H7.863z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeamsFill);
export default __webpack_public_path__ + "35bb1dfab4e00c079714b230bcdb5898.svg";
export { ForwardRef as ReactComponent };